import type { PersonBrief } from "../api/types";

export function PersonCell({ person, detail }: { person: Pick<PersonBrief, "name" | "title">; detail?: string | null }) {
  const sub = detail ?? person.title;
  return (
    <span className="ada-person">
      <span className="ada-person__name">{person.name}</span>
      {sub ? <span className="ada-person__title">{sub}</span> : null}
    </span>
  );
}

/** "Camille Roux, Alex Martin" or a dash. */
export function names(people: Array<Pick<PersonBrief, "name">>): string {
  return people.length ? people.map((p) => p.name).join(", ") : "—";
}
